import { render, staticRenderFns } from "./TherapyDrugsForm.vue?vue&type=template&id=5105214a&"
import script from "./TherapyDrugsForm.vue?vue&type=script&lang=js&"
export * from "./TherapyDrugsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports